import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("cctv_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      const url = err.config?.url || "";
      // Skip auto-logout for business 401s (login itself, wrong current password on change)
      const isBusiness401 = url.includes("/auth/change-password") || url.includes("/auth/login") || url.includes("/auth/operator-login");
      const path = window.location.pathname;
      if (!isBusiness401 && path !== "/login" && path !== "/") {
        localStorage.removeItem("cctv_token");
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

export function streamUrl(footageId) {
  const token = localStorage.getItem("cctv_token");
  return `${API}/footage/${footageId}/stream?auth=${encodeURIComponent(token || "")}`;
}

export function formatApiError(err) {
  const d = err?.response?.data?.detail;
  if (!d) return err?.message || "Unknown error";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return String(d);
}

export default api;
